export const WizardAssetSlugs = Object.freeze({
  HR_WIZARD_FINAL_OUTRO_IMAGE: '4GqJ4fygr5WbMQ9GAjFSID',
});

export default WizardAssetSlugs;
